import initCookies from './components/cookies';
import initSplash from './components/splash';
import initHoverMedia from './components/hover-media';

// Initialise Cookies first so show() works in splash
initCookies();

const splashEl = document.querySelector('.js-splash');

if (splashEl) {
    initSplash(splashEl);
}

const hoverMediaEl = document.querySelector('.js-hover-media');

if (hoverMediaEl) {
    initHoverMedia(hoverMediaEl);
}
